const formatLoadingDisplay = (loading: number): number => {
  const rounded = Math.round(loading * 10000) / 10000;
  const displayedLoading = +(rounded * 100).toFixed(2);

  return displayedLoading;
};

export default formatLoadingDisplay;
